var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioOn = function SvgAudioOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.599 16q-1.29 0-1.945-.654Q0 14.7 0 13.428V2.58Q0 1.3.654.654 1.308 0 2.6 0h10.793q1.3 0 1.954.663.654.654.654 1.918v10.847q0 1.273-.654 1.918-.654.654-1.954.654zm7.125-3.686a.455.455 0 0 0 .468-.469V4.19a.5.5 0 0 0-.132-.354.44.44 0 0 0-.345-.15q-.24 0-.548.274L7 6.046a.23.23 0 0 1-.168.062H5.34q-.433 0-.69.257-.246.247-.247.707v1.892q0 .46.248.716.255.255.69.256h1.493q.098 0 .168.053l2.166 2.068q.265.257.557.257"
  })));
};
export default SvgAudioOn;